webpackJsonp([9],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dschau/Code/Personal/gatsby-images-issue-example/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dschau/Code/Personal/gatsby-images-issue-example/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dschau/Code/Personal/gatsby-images-issue-example/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dschau/Code/Personal/gatsby-images-issue-example/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/Users/dschau/Code/Personal/gatsby-images-issue-example/node_modules/babel-preset-env/lib/index.js\",\"/Users/dschau/Code/Personal/gatsby-images-issue-example/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dschau/Code/Personal/gatsby-images-issue-example/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageQuery = undefined;
	exports.default = Index;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Index(_ref) {
	  var data = _ref.data;
	  var posts = data.allMarkdownRemark.edges;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'blog-posts' },
	    posts.sort(function (a, b) {
	      var getDate = function getDate(post) {
	        return new Date(post.node.frontmatter.date);
	      };
	
	      return getDate(a) - getDate(b);
	    }).reverse() // newest first
	    .filter(function (post) {
	      return post.node.frontmatter.title.length > 0;
	    }).map(function (_ref2) {
	      var post = _ref2.node;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'blog-post-preview', key: post.id },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: post.frontmatter.path },
	            post.frontmatter.title
	          )
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          post.frontmatter.date
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          post.excerpt
	        )
	      );
	    })
	  );
	}
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-index-js-63afa9b8a21c0c487a08.js